var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("RadioGroup", {
        attrs: {
          options: [
            { value: true, text: "Ja" },
            { value: false, text: "Nein" }
          ]
        },
        on: { change: _vm.emitChangeEvent },
        model: {
          value: _vm.necessary,
          callback: function($$v) {
            _vm.necessary = $$v
          },
          expression: "necessary"
        }
      }),
      _vm._v(" "),
      _vm.extraDataEligible
        ? _c("div", { staticClass: "sections mt-4" }, [
            _c(
              "section",
              [
                _c("h3", [_vm._v("Wohin gehen die Reisen?")]),
                _vm._v(" "),
                _c("CharacteristicEdit", {
                  attrs: {
                    title: "Wohin gehen die Reisen?",
                    "characteristic-items": _vm.geoCharacteristicItems,
                    "characteristic-type": _vm.meta.geoType,
                    "nothing-allowed": {
                      onlyOverall: true,
                      overall: {
                        text: "Weltweit"
                      }
                    },
                    "selected-items-config": {
                      showExperience: false
                    },
                    "group-by-letter": {
                      enabled: false
                    },
                    "with-keyword": "",
                    "open-fan-button-alignment": "left",
                    "label-type": "job-profile"
                  },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.geo,
                    callback: function($$v) {
                      _vm.geo = $$v
                    },
                    expression: "geo"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("h3", [
                  _vm._v(
                    "Wie viele Tage pro Monat muss im Durchschnitt gereist werden?"
                  )
                ]),
                _vm._v(" "),
                _c("CharacteristicSelectInline", {
                  attrs: {
                    "characteristic-items": _vm.meta.travelWillingness,
                    "initial-show-all": "",
                    "single-choice": "",
                    "label-type": "job-profile"
                  },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.scope,
                    callback: function($$v) {
                      _vm.scope = $$v
                    },
                    expression: "scope"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("h3", [_vm._v("Gibt es externe Übernachtungen?")]),
                _vm._v(" "),
                _c("CharacteristicSelectInline", {
                  attrs: {
                    "characteristic-items": _vm.meta.externalSleepover,
                    "initial-show-all": "",
                    "nothing-allowed": {
                      text: "Es sind keine externen Übernachtungen nötig"
                    },
                    "single-choice": "",
                    "label-type": "job-profile"
                  },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.externalSleepover,
                    callback: function($$v) {
                      _vm.externalSleepover = $$v
                    },
                    expression: "externalSleepover"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }